/**
 * Format price
 *
 * @export
 * @param {number} price
 * @returns {string}
 */
export function formatPrice(price: number): string {
  const priceBase = Math.round(price);
  const rest = Math.round(price * 100) - priceBase * 100;
  const afterText = rest ? ',' + ('' + rest).padStart(2, '0') : ',-';
  return priceBase + afterText;
}
